import Api from "../../../src/lib/api";

export const GENERAL_INFO = {
  start: "fetch_start/general_info",
  end: "fetch_end/general_info",
  success: "fetch_success/general_info",
  failed: "fetch_failed/general_info",
};
export const generalInfoFetchStart = () => ({
  type: GENERAL_INFO.start,
});
export const generalInfoFetchEnd = () => ({
  type: GENERAL_INFO.end,
});
export const generalInfoFetchSuccess = (data) => ({
  type: GENERAL_INFO.success,
  data,
});
export const generalInfoFetchFailed = (error) => ({
  type: GENERAL_INFO.failed,
  error,
});
export const fetchGeneralInfoData = () => (dispatch) => {
  dispatch(generalInfoFetchStart());
  return Api.get(Api.API_GENERAL_INFO)
    .then((resp) => {
      dispatch(generalInfoFetchEnd());
      dispatch(generalInfoFetchSuccess(resp));
    })
    .catch((exception) => {
      dispatch(generalInfoFetchEnd());
      dispatch(generalInfoFetchFailed());
    });
};



// WEBPACK FOOTER //
// ./shared/actions/getGeneralInfo.js